import { SectionBreak, Button, H2 } from "govuk-react";
import React, { memo } from "react";
import { PrePpWlEssentialSection } from "./PrePpWlEssentialSection";
import { PrePpWlOptionalSection } from "./PrePpWlOptionalSection";
import { PrePpWlFormComponentStepProps } from "../PrePublicPortalWlForm";
import Box from "@mui/material/Box";
import { useForm } from "../hooks/formContext";

export const PrePpWlAdditionalInformationStep = memo((props: PrePpWlFormComponentStepProps) => {
    const { next } = props;
    const { previous } = useForm();

    return (
        <>
            <H2>Additional Information</H2>
            <SectionBreak level="LARGE" visible />

            <PrePpWlEssentialSection />
            <PrePpWlOptionalSection />

            <Box display="flex" justifyContent="space-between">
                <Button onClick={previous}>Previous</Button>
                <Button onClick={next}>Next</Button>
            </Box>
        </>
    );
});
